module.exports = __webpack_public_path__ + "img/ertiga-xl7-boostergreen.79ce68c4.svg";